import { useEffect } from 'react';

import { captureEvent } from '@sentry/browser';

import {
  clearSessionData,
  clearAutolistCoreSequenceNumberItems,
  getLocalStorageSpaceAudit,
} from '../EventLogger/LocalStorageStore';

export default function useQuotaLimitErrorHandling(): void {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('error', handleQuotaLimitError);
      return (): void => {
        window.removeEventListener('error', handleQuotaLimitError);
      };
    }

    return undefined;
  }, []);
}

function handleQuotaLimitError({ error }: ErrorEvent): void {
  if (error instanceof DOMException && error.code === DOMException.QUOTA_EXCEEDED_ERR) {
    const auditData = getLocalStorageSpaceAudit();
    captureEvent({
      message: 'Auditing local storage space usage',
      extra: { auditData },
    });
    clearSessionData();
    clearAutolistCoreSequenceNumberItems();
  }

  throw error;
}
